import AppRouter from 'common/AppRouter';
import useTabsBuilder from 'components/RouterTabs/useTabsBuilder';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import CopilotSetting from './CopilotSetting';

const useAiIntegrationsTabs = () => {
  const tabsBuilder = useTabsBuilder();

  tabsBuilder.initTabs(
    [
      {
        name: 'GitHub Copilot',
        path: AppRouter.AI_INTEGRATIONS_SETTINGS.GITHUB_COPILOT.path,
        permissions: {
          featureFlagName:
            FEATURE_FLAGS_NAMES.isCopilotTrackingIntegrationEnabled
        },
        component: <CopilotSetting />
      }
      // {
      //   name: 'Cursor',
      //   path: AppRouter.AI_INTEGRATIONS_SETTINGS.CURSOR.path,
      //   permissions: {
      //     featureFlagName:
      //       FEATURE_FLAGS_NAMES.isCursorTrackingIntegrationEnabled
      //   },
      //   component: <div>Cursor</div>
      // }
    ].filter(Boolean)
  );
  return tabsBuilder.build();
};

export default useAiIntegrationsTabs;
